import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { showError, showSuccess } from "../../utils/toastUtils";

import axios from "../../api/axiosinstance";

import { motion } from "framer-motion";
import PageTransition from "../../components/PageTransition";
import axiosInstance from "../../api/axiosinstance";

/* ================= RESPONSIVE HOOK ================= */
// Simple hook jo window width track karta hai, taaki hum
// breakpoints ke hisaab se styles switch kar saken.
function useWindowWidth() {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200,
  );

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
}

function AgreementOTPView() {
  const { id } = useParams();

  const navigate = useNavigate();

  const [otp, setOtp] = useState("");

  const [loading, setLoading] = useState(false);

  const [paymentData, setPaymentData] = useState(null);

  const [agreementData, setAgreementData] = useState(null);

  const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);

  const inputRefs = useRef([]);

  const width = useWindowWidth();
  const isMobile = width <= 768;
  const isSmallMobile = width <= 380;
  const isTablet = width > 768 && width <= 1024;

  /* ================= FETCH AGREEMENT ================= */
  useEffect(() => {
    if (id) {
      trackOtpPage();
    }
  }, [id]);

  const trackOtpPage = async () => {
    try {
      await axiosInstance.post("/client-journey/track", {
        agreementId: id,

        step: "otp_page_opened",

        page: window.location.pathname,

        description: "Client opened OTP page",
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (id) {
      fetchAgreementDetails();
    }
  }, [id]);

  const fetchAgreementDetails = async () => {
    try {
      const res = await axios.get(`/service-agreement/by-id/${id}`);

      console.log("AGREEMENT DATA", res.data);

      setAgreementData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const maskedMobile = agreementData?.leadId?.phone
    ? `XXXXXX${String(agreementData.leadId.phone).slice(-4)}`
    : agreementData?.leadId?.whatsapp_number
      ? `XXXXXX${String(agreementData.leadId.whatsapp_number).slice(-4)}`
      : agreementData?.leadId?.alternate_number
        ? `XXXXXX${String(agreementData.leadId.alternate_number).slice(-4)}`
        : "Loading...";

  const handleOtpChange = (value, index) => {
    // ONLY NUMBER

    if (!/^\d*$/.test(value)) return;

    const updatedOtp = [...otpValues];

    updatedOtp[index] = value;

    setOtpValues(updatedOtp);

    const finalOtp = updatedOtp.join("");

    setOtp(finalOtp);

    // AUTO NEXT

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    // BACKSPACE PREVIOUS

    if (e.key === "Backspace" && !otpValues[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();

    const pastedData = e.clipboardData.getData("text").trim();

    if (!/^\d+$/.test(pastedData)) return;

    const otpArray = pastedData.slice(0, 6).split("");

    const updatedOtp = [...otpValues];

    otpArray.forEach((digit, index) => {
      updatedOtp[index] = digit;
    });

    setOtpValues(updatedOtp);

    setOtp(updatedOtp.join(""));

    // AUTO FOCUS LAST

    const lastIndex = otpArray.length >= 6 ? 5 : otpArray.length;

    inputRefs.current[lastIndex]?.focus();
  };

  /* ================= VERIFY OTP ================= */

  const handleVerifyOTP = async () => {
    try {
      setLoading(true);

      const res = await axios.post("/service-agreement/verify-otp", {
        agreementId: id,
        otp,
      });

      await axiosInstance.post("/client-journey/track", {
        agreementId: id,

        step: "otp_verified",

        page: window.location.pathname,

        description: "Client verified OTP",
      });

      if (res?.success === true) {
        showSuccess("OTP verified successfully");

        navigate(`/agreement/payment/${id}`);
      }
    } catch (err) {
      console.log(err);

      showError(err?.message || "OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  /* ================= PAYMENT ================= */

  const handlePayment = async (type) => {
    try {
      const res = await axios.post("/payment/create-order", {
        agreementId: paymentData.agreementId,

        paymentType: type,
      });

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY,

        amount: res.amount,

        currency: res.currency,

        order_id: res.orderId,

        name: "Axepert Services",

        description: type === "full" ? "Full Payment" : "Partial Payment",

        handler: async function (response) {
          try {
            const verifyRes = await axios.post("/payment/verify", {
              razorpay_order_id: response.razorpay_order_id,

              razorpay_payment_id: response.razorpay_payment_id,

              razorpay_signature: response.razorpay_signature,
            });

            if (verifyRes.success) {
              showSuccess("Payment Successful");
            }
          } catch (err) {
            console.log(err);

            showError("Payment verification failed");
          }
        },

        theme: {
          color: "#5a140c",
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.open();
    } catch (err) {
      console.log(err);

      showError("Payment failed");
    }
  };

  // OTP box sizing — mobile pe 6 boxes ek line me fit hone chahiye
  const otpBoxSize = isSmallMobile
    ? { w: 42, h: 50, font: 18, gap: 8 }
    : isMobile
      ? { w: 48, h: 56, font: 20, gap: 10 }
      : { w: 68, h: 74, font: 28, gap: 14 };

  return (
    <PageTransition>
      <div
        style={{
          minHeight: "100vh",
          background: "#f4f0ec",
          padding: isMobile ? "16px 10px" : "40px 20px",
        }}
      >
        {/* MAIN WRAPPER */}

        <div
          style={{
            maxWidth: "1350px",
            margin: "0 auto",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "18px" : "35px",
            alignItems: isMobile ? "stretch" : "flex-start",
          }}
        >
          {/* LEFT PANEL */}

          <div
            style={{
              width: isMobile ? "100%" : isTablet ? "260px" : "340px",
              minWidth: isMobile ? "100%" : isTablet ? "260px" : "340px",
              background: "#5a140c",
              borderRadius: isMobile ? "20px" : "28px",
              padding: isMobile ? "24px 22px" : "40px 35px",
              color: "#fff",
              position: isMobile ? "relative" : "sticky",
              top: "20px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                width: isMobile ? "140px" : "220px",
                height: isMobile ? "140px" : "220px",
                borderRadius: "50%",
                background: "rgba(255,255,255,0.05)",
                top: "-80px",
                right: "-80px",
              }}
            />

            <img
              src="/assets/img/whitelogo.png"
              alt=""
              style={{
                width: isMobile ? "100px" : "130px",
                marginBottom: isMobile ? "20px" : "35px",
              }}
            />

            <h1
              style={{
                fontSize: isMobile ? "28px" : isTablet ? "34px" : "42px",
                lineHeight: isMobile ? "36px" : isTablet ? "44px" : "52px",
                fontWeight: "700",
                marginBottom: isMobile ? "16px" : "25px",
                color: "#fff",
              }}
            >
              SERVICE
              <br />
              AGREEMENT
            </h1>

            <div
              style={{
                width: "90px",
                height: "3px",
                background: "#ffffff",
                marginBottom: isMobile ? "18px" : "30px",
              }}
            />

            <p
              style={{
                lineHeight: isMobile ? "24px" : "32px",
                color: "rgba(255,255,255,0.82)",
                fontSize: isMobile ? "13px" : "15px",
              }}
            >
              Please review all terms carefully before proceeding further. This
              agreement becomes effective once you verify the OTP and complete
              payment.
            </p>

            {/* STEPS */}

            <div
              style={{
                marginTop: isMobile ? "24px" : "45px",
                display: "flex",
                flexDirection: isMobile ? "row" : "column",
                flexWrap: "wrap",
                gap: isMobile ? "12px" : "18px",
              }}
            >
              {/* STEP 1 */}

              <div
                style={{
                  flex: isMobile ? "1 1 auto" : "unset",
                  minWidth: isMobile ? "90px" : "auto",
                  background: "rgba(255,255,255,0.12)",

                  border: "1px solid rgba(255,255,255,0.08)",

                  padding: isMobile ? "10px 12px" : "18px",

                  borderRadius: isMobile ? "14px" : "18px",
                }}
              >
                <div
                  style={{
                    fontSize: isMobile ? "11px" : "13px",
                    opacity: 0.7,
                    marginBottom: isMobile ? "4px" : "8px",
                  }}
                >
                  Step 1
                </div>

                <div
                  style={{
                    fontWeight: "600",
                    fontSize: isMobile ? "13px" : "16px",
                  }}
                >
                  Review Agreement
                </div>
              </div>

              {/* STEP 2 ACTIVE */}

              <div
                style={{
                  flex: isMobile ? "1 1 auto" : "unset",
                  minWidth: isMobile ? "90px" : "auto",
                  background: "rgba(255,255,255,0.22)",

                  border: "1px solid rgba(255,255,255,0.15)",

                  boxShadow: "0 0 20px rgba(255,255,255,0.08)",

                  padding: isMobile ? "10px 12px" : "18px",

                  borderRadius: isMobile ? "14px" : "18px",
                }}
              >
                <div
                  style={{
                    fontSize: isMobile ? "11px" : "13px",
                    opacity: 0.7,
                    marginBottom: isMobile ? "4px" : "8px",
                  }}
                >
                  Step 2
                </div>

                <div
                  style={{
                    fontWeight: "600",
                    fontSize: isMobile ? "13px" : "16px",
                  }}
                >
                  OTP Verification
                </div>
              </div>

              {/* STEP 3 */}

              <div
                style={{
                  flex: isMobile ? "1 1 auto" : "unset",
                  minWidth: isMobile ? "90px" : "auto",
                  background: "rgba(255,255,255,0.06)",

                  border: "1px solid rgba(255,255,255,0.08)",

                  padding: isMobile ? "10px 12px" : "18px",

                  borderRadius: isMobile ? "14px" : "18px",
                }}
              >
                <div
                  style={{
                    fontSize: isMobile ? "11px" : "13px",
                    opacity: 0.7,
                    marginBottom: isMobile ? "4px" : "8px",
                  }}
                >
                  Step 3
                </div>

                <div
                  style={{
                    fontWeight: "600",
                    fontSize: isMobile ? "13px" : "16px",
                  }}
                >
                  Payment Process
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT PANEL */}

          <div
            style={{
              flex: 1,
              width: isMobile ? "100%" : "auto",
              minWidth: 0,
            }}
          >
            {/* OTP CARD */}

            <motion.div
              style={{
                background: "#fff",
                borderRadius: isMobile ? "18px" : "28px",
                border: "1px solid #eaded8",
                boxShadow: "0 10px 35px rgba(0,0,0,0.05)",
                overflow: "hidden",
              }}
            >
              {/* TOP BAR */}

              <div
                style={{
                  padding: isMobile ? "18px" : "28px 35px",
                  borderBottom: "1px solid #f0e7e3",
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  justifyContent: "space-between",
                  alignItems: isMobile ? "flex-start" : "center",
                  gap: isMobile ? "12px" : "0",
                }}
              >
                <div>
                  <h2
                    style={{
                      margin: 0,
                      color: "#5a140c",
                      fontSize: isMobile ? "20px" : "28px",
                      fontWeight: "700",
                    }}
                  >
                    OTP Verification
                  </h2>

                  <div
                    style={{
                      marginTop: "8px",
                      color: "#777",
                      fontSize: isMobile ? "13px" : "14px",
                    }}
                  >
                    Enter the OTP sent to your registered mobile number.
                  </div>
                </div>

                <div
                  style={{
                    background: "#fff5f2",

                    color: "#d35400",

                    padding: isMobile ? "8px 14px" : "12px 18px",

                    borderRadius: "14px",

                    fontSize: isMobile ? "12px" : "14px",

                    fontWeight: "600",

                    whiteSpace: "nowrap",
                  }}
                >
                  Step 2 of 3
                </div>
              </div>

              {/* BODY */}

              <div
                style={{
                  padding: isMobile ? "22px 18px" : "60px",
                  display: "flex",
                  flexDirection: isMobile || isTablet ? "column" : "row",
                  alignItems: isMobile || isTablet ? "stretch" : "center",
                  justifyContent: "space-between",
                  gap: isMobile ? "24px" : "50px",
                }}
              >
                {/* LEFT */}

                <div
                  style={{
                    flex: 1,
                  }}
                >
                  <h1
                    style={{
                      fontSize: isMobile ? "26px" : "46px",
                      color: "#5a140c",
                      marginBottom: isMobile ? "10px" : "15px",
                    }}
                  >
                    Verify OTP
                  </h1>

                  <div
                    style={{
                      marginTop: isMobile ? "10px" : "18px",
                      marginBottom: isMobile ? "24px" : "40px",
                      maxWidth: "760px",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        background: "linear-gradient(135deg,#fff7f4,#ffffff)",
                        border: "1px solid #f3d9d1",
                        borderRadius: isMobile ? "18px" : "28px",
                        padding: isMobile ? "18px" : "30px",
                        boxShadow: "0 12px 30px rgba(123,20,8,0.08)",
                      }}
                    >
                      {/* BG EFFECT */}

                      <div
                        style={{
                          position: "absolute",
                          width: "200px",
                          height: "200px",
                          borderRadius: "50%",
                          background: "rgba(123,20,8,0.05)",
                          top: "-90px",
                          right: "-80px",
                        }}
                      />

                      {/* CONTENT */}

                      <div
                        style={{
                          display: "flex",
                          flexDirection: isSmallMobile ? "column" : "row",
                          alignItems: isSmallMobile ? "flex-start" : "center",
                          gap: isMobile ? "14px" : "22px",
                          position: "relative",
                          zIndex: 2,
                        }}
                      >
                        {/* ICON */}

                        <div
                          style={{
                            minWidth: isMobile ? "56px" : "78px",
                            width: isMobile ? "56px" : "78px",
                            height: isMobile ? "56px" : "78px",
                            borderRadius: isMobile ? "16px" : "22px",
                            background:
                              "linear-gradient(135deg,#7b1408,#b84d2c)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            fontSize: isMobile ? "24px" : "34px",
                            boxShadow: "0 10px 25px rgba(123,20,8,0.25)",
                            flexShrink: 0,
                          }}
                        >
                          📲
                        </div>

                        {/* TEXT */}

                        <div>
                          <div
                            style={{
                              fontSize: isMobile ? "11px" : "13px",
                              fontWeight: "700",
                              letterSpacing: "1.5px",
                              textTransform: "uppercase",
                              color: "#c96f42",
                              marginBottom: isMobile ? "6px" : "10px",
                            }}
                          >
                            Secure OTP Verification
                          </div>

                          <div
                            style={{
                              fontSize: isMobile ? "20px" : "30px",
                              fontWeight: "800",
                              color: "#5a140c",
                              lineHeight: isMobile ? "26px" : "40px",
                              marginBottom: isMobile ? "6px" : "10px",
                            }}
                          >
                            OTP Sent Successfully
                          </div>

                          <div
                            style={{
                              color: "#666",
                              fontSize: isMobile ? "13px" : "16px",
                              lineHeight: isMobile ? "20px" : "30px",
                              maxWidth: "540px",
                            }}
                          >
                            We have securely sent a verification code to your
                            registered mobile number. Please enter the OTP below
                            to continue the agreement process.
                          </div>
                        </div>
                      </div>

                      {/* MOBILE CARD */}

                      <div
                        style={{
                          marginTop: isMobile ? "18px" : "28px",
                          background: "#ffffff",
                          border: "1px solid #f0d7cf",
                          borderRadius: isMobile ? "16px" : "20px",
                          padding: isMobile ? "12px 16px" : "18px 24px",
                          display: "flex",
                          alignItems: "center",
                          gap: isMobile ? "12px" : "16px",
                          width: isMobile ? "100%" : "fit-content",
                          position: "relative",
                          zIndex: 2,
                          boxShadow: "0 6px 18px rgba(123,20,8,0.06)",
                        }}
                      >
                        <div
                          style={{
                            width: isMobile ? "44px" : "58px",
                            height: isMobile ? "44px" : "58px",
                            borderRadius: isMobile ? "14px" : "18px",
                            background: "#fff5f2",
                            border: "1px solid #f1d5cc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: isMobile ? "20px" : "26px",
                            flexShrink: 0,
                          }}
                        >
                          📱
                        </div>

                        <div>
                          <div
                            style={{
                              fontSize: isMobile ? "10px" : "12px",
                              color: "#999",
                              marginBottom: "6px",
                              fontWeight: "700",
                              letterSpacing: "1px",
                            }}
                          >
                            REGISTERED MOBILE NUMBER
                          </div>

                          <div
                            style={{
                              color: "#7b1408",
                              fontWeight: "800",
                              fontSize: isMobile ? "18px" : "26px",
                              letterSpacing: isMobile ? "2px" : "4px",
                            }}
                          >
                            {maskedMobile}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    onPaste={handlePaste}
                    style={{
                      display: "flex",
                      gap: `${otpBoxSize.gap}px`,
                      flexWrap: "wrap",
                      marginBottom: "10px",
                    }}
                  >
                    {otpValues.map((digit, index) => (
                      <motion.input
                        key={index}
                        ref={(el) => (inputRefs.current[index] = el)}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleOtpChange(e.target.value, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        initial={{
                          scale: 0.9,
                          opacity: 0,
                        }}
                        animate={{
                          scale: 1,
                          opacity: 1,
                        }}
                        transition={{
                          delay: index * 0.05,
                        }}
                        whileFocus={{
                          scale: 1.08,
                        }}
                        style={{
                          width: `${otpBoxSize.w}px`,
                          height: `${otpBoxSize.h}px`,
                          borderRadius: isMobile ? "12px" : "18px",
                          border:
                            digit.length > 0
                              ? "2px solid #7b1408"
                              : "2px solid #eaded8",

                          background: digit.length > 0 ? "#fff7f3" : "#fff",

                          textAlign: "center",

                          fontSize: `${otpBoxSize.font}px`,

                          fontWeight: "700",

                          color: "#5a140c",

                          outline: "none",

                          transition: "0.3s",

                          boxShadow:
                            digit.length > 0
                              ? "0 0 20px rgba(123,20,8,0.18)"
                              : "0 4px 10px rgba(0,0,0,0.04)",
                        }}
                      />
                    ))}
                  </div>

                  <button
                    onClick={handleVerifyOTP}
                    disabled={loading}
                    style={{
                      width: isMobile ? "100%" : "auto",
                      marginTop: isMobile ? "18px" : "28px",
                      border: "none",
                      background: "#7b1408",
                      color: "#fff",
                      padding: isMobile ? "14px 24px" : "16px 34px",
                      borderRadius: "14px",
                      fontSize: isMobile ? "15px" : "16px",
                      fontWeight: "600",
                      cursor: "pointer",
                    }}
                  >
                    {loading ? "Verifying..." : "Verify OTP"}
                  </button>
                </div>

                {/* RIGHT IMAGE */}

                {!isMobile && (
                  <div>
                    <img
                      src="/assets/img/otp-image.png"
                      alt=""
                      style={{
                        width: isTablet ? "220px" : "320px",
                      }}
                    />
                  </div>
                )}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </PageTransition>
  );
}

export default AgreementOTPView;
